import ThreeDotsHorizontal from './src/three-dots-horizontal-combined';
export default ThreeDotsHorizontal;